import React, {Fragment} from "react";
import StepLoadingComponent from "components/Step/StepLoadingComponent";
import {Input} from "reactstrap";
import StepButton from "components/Step/StepButton";
import StepQuestion from "components/Step/StepQuestion";
import ReportingDeclarationService
    from "../../../../services/Transaction/reporting.declaration/ReportingDeclarationService";
import ReportingDeclarationComponent from "../../../../components/ReportingDeclarationComponent";


export default class BopCategoryStep extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            loading: true,
            bopCategories: undefined,
            accepted: false
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData(){
        let requests = [];
        requests.push(ReportingDeclarationService.getLatestVersion(false));

        Promise.all(requests).then(responseArray => {
            let declaration = responseArray[0];

            this.setState({
                loading: false,
                declaration: declaration
            });
        });
    }

    toggleAccept(event) {
        this.setState({
            accepted: event.target.checked
        }, () => {
            if (this.state.accepted) {
                this.props.onDeclarationSigned(this.state.declaration.version)
            }
        })
    }

    render() {
        if (this.state.loading) {
            return <StepLoadingComponent/>
        }

        return <div className={"step_card_no_scroll"}>
            <div className={"step_selection_list"} style={{
                maxHeight: "calc(100% - 115px)"
            }}>
                <div className={"step_declaration"}>
                    <StepQuestion>
                        Please read the terms and conditions and accept:
                    </StepQuestion>
                    {this.renderDeclaration()}
                    <hr/>
                    <div className={"step_declaration_accept"}>
                        <Input style={{scale: "1.5"}}
                               onChange={this.toggleAccept.bind(this)}
                               type="checkbox"
                               checked={this.state.accepted}
                        />
                        <span>I accept and acknowledge the declaration</span>
                    </div>
                </div>
            </div>
            <StepButton
                disabled={this.state.accepted !== true}
                onClick={this.props.onNextClick}
            >
                Finish
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                Back
            </StepButton>

        </div>
    }

    renderDeclaration() {
        return <Fragment>
            <ReportingDeclarationComponent/>
        </Fragment>
    }
}